import { render } from "./ZhaiTwoTuttons.vue?vue&type=template&id=30092d5f&scoped=true"
import script from "./ZhaiTwoTuttons.vue?vue&type=script&lang=js"
export * from "./ZhaiTwoTuttons.vue?vue&type=script&lang=js"

import "./ZhaiTwoTuttons.vue?vue&type=style&index=0&id=30092d5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30092d5f"]])

export default __exports__